export enum EmailChangeResponseStatus {
  EMAIL_CREATE = 'EMAIL_CREATE',
  EMAIL_CHANGE = 'EMAIL_CHANGE',
  WRONG_EMAIL = 'WRONG_EMAIL',
  WRONG_PASSWORD = 'WRONG_PASSWORD',
  EMAIL_LOCKED = 'EMAIL_LOCKED',
}

export interface EmailChangeResponseDTO {
  status: EmailChangeResponseStatus;
}
